import { HolidaysManager } from "./HolidaysManager";
import { eachWeekendOfInterval } from "date-fns";

export class GeneralDelivery{
    constructor(protected holidaysManager: HolidaysManager) {
    }

    protected countWeekendsInInterval(startDate: Date, endDate: Date) {
        const weekends = eachWeekendOfInterval({start: startDate, end: endDate});
        return weekends.length;
    }
}
